import { CircularProgress, IconButton, SvgIcon, Tooltip } from '@mui/material';
import { Close as CloseIcon } from '@opengov/react-capital-assets';
import React from 'react';

import { MuiSxProps } from '../types';

import { NAV_COLOR_PALETTE, tooltipOffsetProps } from './styleConstants';

interface ICloseButtonProps {
  toolTipText?: string;
  styleOverrides?: MuiSxProps;
  loading?: boolean;
  dataTest?: string;
  tabIndex?: number;
  onClick(e): void;
  onKeyDown?(e): void;
}

export const CloseButton = React.forwardRef<HTMLButtonElement, ICloseButtonProps>(
  ({ onClick, onKeyDown, dataTest, toolTipText = '', loading = false, styleOverrides, tabIndex }, ref) => {
    return (
      <Tooltip
        title={toolTipText}
        placement="top"
        enterNextDelay={500}
        disableInteractive={true}
        {...tooltipOffsetProps}
      >
        <IconButton
          disableRipple={true}
          data-test={dataTest}
          tabIndex={tabIndex}
          ref={ref}
          sx={{
            padding: 1,
            borderRadius: 0.5,
            '&.Mui-focusVisible': {
              // Per MUI docs, Disabling ripple on focus removes all styling
              // Ensure focus style exists for accessibility
              outline: `2px solid ${NAV_COLOR_PALETTE.focus}`
            },
            color: NAV_COLOR_PALETTE.secondaryGray,
            ':hover': {
              color: NAV_COLOR_PALETTE.primaryGray
            },
            ...styleOverrides
          }}
          onClick={onClick}
          onKeyDown={onKeyDown}
          aria-busy={loading}
        >
          {loading && (
            <CircularProgress size={20} sx={{ color: NAV_COLOR_PALETTE.primaryGray }} aria-label="Processing" />
          )}
          {!loading && <SvgIcon inheritViewBox component={CloseIcon} fontSize="small" />}
        </IconButton>
      </Tooltip>
    );
  }
);

CloseButton.displayName = 'CloseButton';
